export { default } from './HoldItem';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldItem/index.js